/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {createVendorData, getVendorData} from '../redux/VendorCRUD'
import * as vendor from '../redux/VendorRedux'
import {CreateVendorForm} from './CreateVendorForm'
import {IVendorFormValues} from './CreateVendorForm'

const ListPage: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  // call initial data for Form
  const callInitialData = async () => {
    try {
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  useEffect(() => {
    callInitialData()
  }, [])

  const callClientData = async () => {
    try {
      let clientData = await getVendorData(0, 10)
      if (clientData.data) {
        await dispatch(vendor.actions.setVendorLoading(true))
        // once vendor data set then loading will automatically off using saga middleware
        await dispatch(vendor.actions.setVendorData(clientData.data.docs))
        await dispatch(vendor.actions.setVendorDataTotal(clientData.data.total))
        history.push('/vendor/list')
      }
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  const addSubmit = async (values: IVendorFormValues) => {
    try {
      await createVendorData(values)
      await callClientData()
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  return (
    <div>
      <CreateVendorForm onSubmit={(values: IVendorFormValues) => addSubmit(values)} />
    </div>
  )
}

const CreateWrapper: FC = () => {
  const intl = useIntl()

  return (
    <div>
      <PageTitle
        breadcrumbs={[
          {
            title: 'create',
            path: '/vendor/list',
            isActive: true,
            isSeparator: false,
          },
          {
            title: 'create',
            path: '/vendor/list',
            isActive: true,
            isSeparator: true,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.VENDOR'})}
      </PageTitle>
      <ListPage />
    </div>
  )
}

export {CreateWrapper}
